import { render, staticRenderFns } from "./pdproduct3.vue?vue&type=template&id=77c08115&scoped=true"
import script from "./pdproduct3.vue?vue&type=script&lang=js"
export * from "./pdproduct3.vue?vue&type=script&lang=js"
import style0 from "./pdproduct3.vue?vue&type=style&index=0&id=77c08115&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c08115",
  null
  
)

export default component.exports